// After-Sales Service page English translations

export default {
  pageTitle: "After-Sales Service",
  breadcrumbHome: "Home",
  breadcrumbServices: "Services",
  breadcrumbCurrent: "After-Sales Service",
  
  // Service links
  customManufacturing: "Custom Manufacturing",
  technicalSupport: "Technical Support",
  afterSalesService: "After-Sales Service",
  qualityAssurance: "Quality Assurance",
  researchDevelopment: "Research & Development",
  globalSupplyChain: "Global Supply Chain",
  
  // Main content
  title: "Comprehensive After-Sales Service",
  description1: "At PT Eagle Industry Indonesia, our commitment to customer satisfaction extends far beyond the initial purchase. Our comprehensive after-sales service program ensures that you receive continuous support throughout the entire lifecycle of our products, maximizing their performance and extending their service life.",
  description2: "We believe that long-term customer relationships are built on reliable support and consistent service delivery. Our after-sales team is dedicated to providing prompt assistance, regular maintenance, and proactive solutions to prevent issues before they impact your operations.",
  
  // Services section
  servicesTitle: "Our After-Sales Service Offerings:",
  services: [
    "Regular maintenance scheduling and performance monitoring",
    "Spare parts management and expedited delivery",
    "Equipment inspection and preventive maintenance programs",
    "Product upgrades and retrofitting services",
    "Warranty management and claim processing",
    "Customer training programs for proper operation and maintenance",
    "Performance tracking and optimization recommendations"
  ],
  
  // Maintenance programs section
  maintenanceTitle: "Maintenance Programs:",
  maintenanceDescription: "Our structured maintenance programs are designed to identify potential issues before they lead to equipment failure. We offer customized maintenance schedules based on operating conditions, usage patterns, and criticality of applications. These programs include detailed inspections, performance testing, and replacement of wear components to ensure continuous reliable operation.",
  
  // Metrics
  serviceAvailability: "Service Availability",
  serviceAvailabilityDesc: "Comprehensive support network with regional service centers",
  responseEfficiency: "Response Efficiency",
  responseEfficiencyDesc: "Quick turnaround times for maintenance and repairs",
  spareParts: "Spare Parts",
  sparePartsDesc: "Strategic inventory ensuring prompt parts availability",
  customerSatisfaction: "Customer Satisfaction",
  customerSatisfactionDesc: "Dedicated account managers for personalized service",
  
  // Service contracts section
  serviceContractsTitle: "Service Contracts:",
  serviceContractsDescription: "We offer flexible service contracts tailored to your specific operational needs and budget requirements. Our service contracts can include regular maintenance visits, emergency response services, parts replacement, and performance guarantees. These contracts provide cost-effective solutions while ensuring optimal equipment performance and reliability.",
  
  // Customer feedback section
  customerFeedbackTitle: "Customer Feedback Integration:",
  customerFeedbackDescription: "We value customer feedback as an essential component of our continuous improvement process. Our after-sales service team regularly collects and analyzes customer feedback to identify opportunities for service enhancement and product improvement. This customer-centric approach ensures that our services evolve to meet changing market needs and exceed expectations.",
  
  // CTA button
  requestSupport: "Request After-Sales Support",
  
  // Related services section
  relatedServicesTitle: "Related Services",
  relatedServicesDescription: "Explore our other comprehensive services",
  technicalSupportDesc: "Expert technical assistance to ensure optimal product performance.",
  qualityAssuranceDesc: "Rigorous quality control processes ensuring international standards compliance.",
  globalSupplyChainDesc: "Efficient global distribution network ensuring timely product delivery.",
  readMore: "Read more"
};